export const CHANGE_DATE = 'CHANGE_DATE'
export const TOGGLE_DATE_PICKER_DIALOG = 'TOGGLE_DATE_PICKER_DIALOG'
export const SELECT_DATE_RANGE = 'SELECT_DATE_RANGE'

export enum TypeAnalysis {
  perDay = 'perDay',
  perClosedPeriods = 'perClosedPeriods',
  perEndDate = 'perEndDate',
}

export const DATE_FORMAT = 'DD.MM.YYYY'
